import React from 'react';
import { Link } from 'react-router-dom';

const CourseCTABottom = (props) => {
  const course = props.course;
  return (
    <section className='detailed-cta'>
			<div className='detailed-cta__top'>
        <Link to={{pathname: '/join', state: { course: course }}}
          className='button button--s'>
            Free Trial
        </Link>
				<Link to={{pathname: '/checkout/register', state: { course: course }}}
          className='button button--pri button--s'>
            Buy Now
        </Link>
        <p><svg className='icon icon-user-group' aria-hidden='true'><use xlinkHref='#user-group' /></svg>Join {course.noOfClassMates} classmates who have taken this course. You're in good company!</p>
			</div>

			<div className='detailed-cta__bottom'>
				<p>You can join today (no credit card required) and try all of our courses out for free. You only need to pay when ready to progress beyond module one. If you decide to progress, the cost of this course is £{course.courseOptions[0].price}.</p>
			</div>
		</section>
  )
};

export default CourseCTABottom;



// WEBPACK FOOTER //
// ./src/components/CourseCTABottom/index.js